import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  menuListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    maxHeight: 30,
    fontSize: "14px",
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div style={{ width: 120, marginTop: -4 }}>
      <FormControl fullWidth margin="dense">
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedQueueIds}
          onChange={handleChange}
          style={{
            border: "none",
            borderRadius: "8px",
            color: "white",
            backgroundColor: theme.mode === 'light' ? "#8E2DE2" : "hsl(270, 80%, 60%)",
            height: 36,
            minWidth: 200,
            boxShadow: theme.mode === 'light' ? "0 2px 8px rgba(142, 45, 226, 0.3)" : "0 4px 12px hsla(270, 80%, 60%, 0.3)",
            transition: "all 0.2s ease",
          }}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&:hover": {
              backgroundColor: theme.mode === 'light' ? "#7A26CC" : "hsla(270, 80%, 60%, 0.9)",
              boxShadow: theme.mode === 'light' ? "0 4px 12px rgba(142, 45, 226, 0.4)" : "0 6px 16px hsla(270, 80%, 60%, 0.4)",
            },
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                borderRadius: 0,
                marginTop: 4,
                backgroundColor: theme.mode === 'light' ? "#ffffff" : "hsl(270, 25%, 10%)",
                color: theme.mode === 'light' ? "inherit" : "hsl(0, 0%, 95%)",
                border: theme.mode === 'dark' ? "1px solid hsl(270, 15%, 18%)" : "none",
              },
            },
            MenuListProps: {
              className: classes.menuListItem,
            },
          }}
          renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
        >
          {userQueues?.length > 0 &&
            userQueues.map((queue) => (
              <MenuItem
                dense
                key={queue.id}
                value={queue.id}
                className={classes.menuItem}
              >
                <Checkbox
                  style={{
                    color: queue.color,
                    padding: 4,
                  }}
                  size="small"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText
                  primary={queue.name}
                  style={{ fontSize: "14px" }}
                />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsQueueSelect;